import { myApi } from '../../config/axiosConfig';

// =========================================
// BUSCAR DASHBOARD POR EVENTO
// =========================================

export const getDashboardByEvent = async ( start, end ) => {

    const response = await myApi.get(`/events/dashboard/events/${start}/${end}`);

    return response.data;

}

// =========================================
// BUSCAR DASHBOARD POR EVENTO ID
// =========================================

export const getDashboardByEventId = async ( id ) => {

    const response = await myApi.get(`/events/dashboard/events/${id}`);

    return response.data;

}

// =========================================
// BUSCAR DASHBOARD POR DRIVER
// =========================================

export const getDashboardByDriver = async ( start, end ) => {

    const response = await myApi.get(`/events/dashboard/drivers/${start}/${end}`);

    return response.data;

}

// =========================================
// BUSCAR DASHBOARD POR DRIVER ID
// =========================================

export const getDashboardByDriverId = async ( id ) => {

    const response = await myApi.get(`/events/dashboard/drivers/${id}`);

    return response.data;

}